import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../components/ui/dialog";
import { ChatSubpage, ChatSubpageApi } from "../../project/chat/chat-subpage";
import { StatusUpdateScope, StatusUpdateUiContext } from "tekkr-common/dist/model/project/chat";
import { DateTime } from "luxon";

export function getInitialMessage(scope: StatusUpdateScope): string {
    switch (scope.type) {
        case "days":
            return `Draft a status update covering the last ${scope.days} days.`;
        case "since_last_update":
            return "Draft a status update covering everything since the last update.";
        case "since_project_start":
            return "Draft a status update covering everything since the project started.";
        case "custom": {
            const start = DateTime.fromISO(scope.startDate).toLocaleString({
                month: "short",
                day: "numeric",
                year: "numeric",
            });
            const end = DateTime.fromISO(scope.endDate).toLocaleString({
                month: "short",
                day: "numeric",
                year: "numeric",
            });
            return `Draft a status update covering ${start} to ${end}.`;
        }
        default:
            return "Draft a status update for me.";
    }
}

interface Props {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    scope: StatusUpdateScope;
    onMarkAsSent: (chatId: string, content: string) => void;
    chatRef: React.RefObject<ChatSubpageApi>;
}

export function UpdateDraftDialog({ open, onOpenChange, scope, onMarkAsSent, chatRef }: Props) {
    const [chatId, setChatId] = useState<string | null>(null);

    const uiContext: StatusUpdateUiContext = {
        type: "status-update",
        scope,
    };

    const handleOpenChange = (newOpen: boolean) => {
        if (!newOpen) {
            setChatId(null);
        }
        onOpenChange(newOpen);
    };

    const handleMarkAsSent = (content: string) => {
        if (!chatId) return;
        onMarkAsSent(chatId, content);
    };

    return (
        <Dialog open={open} onOpenChange={handleOpenChange}>
            <DialogContent className="flex h-[80vh] max-w-4xl flex-col p-0">
                <DialogHeader className="px-6 pt-6">
                    <DialogTitle>Draft Status Update</DialogTitle>
                </DialogHeader>
                <div className="flex min-h-0 flex-1 flex-col">
                    <ChatSubpage
                        ref={chatRef}
                        chatId={chatId}
                        uiContext={uiContext}
                        onChatCreated={setChatId}
                        onMarkAsSent={handleMarkAsSent}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
}
